export default __webpack_public_path__ + "static/media/other-shipment-dark.b2efc5fc.svg";